<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="[]"
      :options="[
        { type:'text', label: '사업장명', value: 'field_name', },
        { type:'text', label: '소속명', value: 'department', readonly: true },
        { type:'text', label: '부서명', value: 'section', readonly: true },
        { type:'text', label: '직책', value: 'rank', readonly: true },
        { type:'text', label: '작성자', value: 'writer_name', readonly: true },
        { type: 'date', label: '작성일', value: 'date', readonly: true },
        { type: 'date', label: '점검일', value: '점검일' },
        { type: 'alert', label: '알림 대상자 선택' },
          ]"
    />

    <!--    청소(미화)-->
    <table-inspect-performance-evaluation
      v-for="(item, indexRows) in form.inspectList"
      class="mt-28px"
      v-model="item.list"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="`${indexRows + 1}. ${item.title}`"
      :sub-title="item.subTitle"
      :is-header-column1="false"
      :is-header-column2="false"
      :is-note="true"
      :is-note2="true"
      :label-column-width="700"
      :total-column-length="6"
      table-header-title="항목"
      table-header-yes="적정"
      table-header-no="미흡"
      table-header-na="해당없음"
      table-header-note="개선사항"
      table-header-note2="비고"
      @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
      @update-note="
          (param1, param2) => {
            updateListNote(indexRows, param1, param2);
          }
        "
    />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    SignField,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        field_name: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        inspectList: [
          {
            title: "필요한 안전 인력 및 예산 확보",
            list: [
              {
                label: "<b>·시설･설비 안전조치, 유지보수 업무 인력 확보</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                label: "<b>·시설물 안전관련 예산 확보</b><br/>" +
                  "&nbsp;&nbsp;- 인건비, 시설물 유지보수 관리비, 안전점검비 등",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
            ]
          },
          {
            title: "안전점검 계획 수립･이행",
            list: [
              {
                label: "<b>·시설물 관련 법령 정기점검 실시</b><br/>" +
                  "&nbsp;&nbsp;- 「시설물 안전법」 상 정기안전점검, 정밀안전점검, 정밀안전진단<br/>" +
                  "&nbsp;&nbsp;- 「건축법」 상 정기점검<br/>" +
                  "&nbsp;&nbsp;- 「소방시설법」 상 종합정밀점검, 작동기능점검<br/>" +
                  "&nbsp;&nbsp;- 기타 업무 소관시설 관련법에 의한 점검",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                label: "<b>·재해발생 우려시기(해빙기, 강풍, 장마기간, 태풍 등) 시설물 수시점검 실시</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
            ]
          },
          {
            title: "‘안전계획’ 수립･이행",
            list: [
              {
                id: 1,
                label: "<b>·중대재해처벌법 적용 시설물에 대한 안전계획 수립(연1회)</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                id: 2,
                label: "<b>·안전관리인력, 안전점검, 유지관리에 관한 사항 안전계획에 포함 및 이행 여부</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
            ]
          },
          {
            title: "재해예방 ‘업무처리 절차’ 마련 및 이행",
            list: [
              {
                id: 1,
                label: "<b>·유해･위험요인 확인･점검 절차 마련</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                id: 2,
                label: "<b>·유해･위험요인 발견 시 조치 절차 마련</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                id: 3,
                label: "<b>·재해발생 시 대응 조치 절차 마련</b><br/>" +
                  "&nbsp;&nbsp;- 긴급구호조치<br/>" +
                  "&nbsp;&nbsp;- 추가 피해방지 조치<br/>" +
                  "&nbsp;&nbsp;- 신고와 원인조사에 따른 개선 조치",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                id: 4,
                label: "<b>·비상대피훈련 계획(제1종시설물)</b>",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
            ]
          },
          {
            title: "도급·용역·위탁 시 기준과 절차 이행",
            subTitle: "*해당할 경우 ‘안전관리능력 산정기준’ 증빙자료로 제출",
            list: [
              {
                label: "<b>·도급･용역･위탁 시 안전보건확보를 위한 기준과 절차 마련 및 점검(연1회)</b><br/>" +
                  "&nbsp;&nbsp;- 중대시민재해예방을 위한 조치능력 및 안전관리능력에 관한 평가기준･절차<br/>" +
                  "&nbsp;&nbsp;- 도급･위탁･용역 등의 업무 수행 시 중대시민재해예방을 위해 필요한 비용에 관한 기준",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
            ]
          },
          {
            title: "안전보건 관계 법령에 따른 의무 이행",
            list: [
              {
                label: "<b>·안전보건 관계 법령에 따른 의무 이행</b><br/>" +
                  "&nbsp;&nbsp;- 도로시설(교량, 터널) : 시설물안전법 등<br/>" +
                  "&nbsp;&nbsp;- 건축물 : 시설물안전법, 건축물관리법, 소방시설법, 초고층재난관리법 등",
                is_checked: "",
                note: "",
                note2: "",
                title: "",
              },
              {
                noLabel: true,
                label: "",
                is_checked: "",
                note: "",
                note2: "",
                title: "소관시설물에 대해 추가해야할 법령 및 의무사항이 있을 경우 포함하여 작성",
              },
            ]
          },
        ],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexList, indexRows, text) {
      this.form.inspectList[indexList].list[indexRows].is_checked = text;
    },
    updateListNote(indexList, indexRows, text) {
      this.form.inspectList[indexList].list[indexRows].note = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
